import {
  isAdministeredEntityPracticeType,
  type AdministeredEntityPracticeType,
  type PracticeSettingsResponse,
} from '@packages/types';

/**
 * Canonical per-kind title for an administered entity: banner, sidebar
 * eyebrow, Settings first tab, Kind row, and the setup picker. A shorter
 * inline label would sentence-case to "Business rescue" and drop the noun -
 * a solvent deceased estate is not a company, and neither is every insolvent
 * entity a company. `account.tsx`'s Kind row and `EntitySetupDialog`'s
 * `ENTITY_KIND_OPTIONS` both read from this record so they cannot drift.
 */
export const ADMINISTERED_ENTITY_KIND_TITLES: Record<AdministeredEntityPracticeType, string> = {
  BUSINESS_RESCUE: 'Company in business rescue',
  INSOLVENCY: 'Insolvency',
  ESTATE_ADMINISTRATION: 'Deceased estate',
};

/**
 * Title for everyday chrome when the signed-in account is an administered
 * entity. Firm practice types and a missing/unknown kind return null so the
 * caller can omit a banner segment or a sidebar eyebrow rather than invent
 * a fallback noun.
 */
export function administeredKindTitle(
  practiceType: PracticeSettingsResponse['practiceType'],
): string | null {
  return isAdministeredEntityPracticeType(practiceType)
    ? ADMINISTERED_ENTITY_KIND_TITLES[practiceType]
    : null;
}
